import { render } from "./overview.vue?vue&type=template&id=56d47686"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"
script.render = render

export default script